// angular
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, inject, input, OnChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
// interfaces & types & enums
import { IBusinessItem } from '../../shared/interfaces/footer-business-item.interface';
import { IPortfolioFooterData } from '@app/+portfolio/shared/interfaces/portfolio-footer-data.interface';
import { IPages, ISocialMedia } from '@app/shared/types/footer-menu.type';
import { Roles } from '@app/shared/enums/roles.enum';
// pipes & constants
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';
import { HasAccessPipe } from '@app/shared/pipes/has-access.pipe';
import {
  portfolioFooterPages1,
  portfolioFooterPages2,
} from '@app/+portfolio/shared/constants/portfolio-footer-data';
import { socialMediaConstant } from '@app/shared/constants/social-media-data.const';

@Component({
  selector: 'pwj-portfolio-footer',
  standalone: true,
  imports: [
    NgOptimizedImage,
    TranslateModule,
    TranslateDataPipe,
    NgClass,
    RouterLink,
  ],
  templateUrl: './portfolio-footer.component.html',
  styleUrl: './portfolio-footer.component.scss',
})
export class PortfolioFooterComponent implements OnChanges {
  // pages
  public pagesFirstSection: IPages[] = portfolioFooterPages1;
  public pagesSecondSection: IPages[] = portfolioFooterPages2;

  public socialMediaConstant = socialMediaConstant;
  public socialMedias: ISocialMedia[] = [];
  public companyInfo!: IBusinessItem[];
  public companyLocation!: IBusinessItem[];
  public hoveredSocialMediaId!: number | null;

  // inputs
  footerData = input.required<IPortfolioFooterData>();

  // dependencies
  private readonly _hasAccessPipe = inject(HasAccessPipe);

  constructor() {}

  ngOnChanges(): void {
    // set company info data
    this.companyInfo = [
      {
        id: 0,
        icon: 'phone',
        name: 'global.phone',
        value: this.footerData()?.mobile || '-',
        valueClasses: `${
          this._hasAccessPipe.transform([Roles.ViewBusinessContactInfo])
            ? ''
            : ''
        } direction-ltr`,
      },
      {
        id: 1,
        icon: 'globe',
        name: 'global.website',
        value: this.footerData()?.website_url || '-',
        isLink: true,
      },
      {
        id: 2,
        icon: 'gps',
        name: 'global.address',
        value: this.footerData()?.address || '-',
        valueClasses: this._hasAccessPipe.transform([
          Roles.ViewBusinessContactInfo,
        ])
          ? ''
          : '',
      },
    ];

    // set company social media
    this.footerData()?.links?.map(link => {
      this.socialMedias.push();
    });

    // set company location data
    this.companyLocation = [
      {
        id: 0,
        icon: 'globe',
        name: 'global.country',
        value: this.footerData()?.country || '-',
      },
      {
        id: 1,
        icon: 'map-2',
        name: 'global.province',
        value: this.footerData()?.province || '-',
      },
      {
        id: 2,
        icon: 'map-3',
        name: 'global.city',
        value: this.footerData()?.city || '-',
      },
    ];
  }

  public onIconHover(socialId: number) {
    this.hoveredSocialMediaId = socialId;
  }

  public onIconHoverFinish() {
    this.hoveredSocialMediaId = null;
  }
}
